import { toStreamID, toUserId } from '@streamr/utils';
import { z } from 'zod';
import { KeyStore } from '../../engine/helpers/KeyStore';
import { safeRetrieve, safeStore } from '../../utils/storage';
import { formFullStreamId } from '../../utils/streamId';
import { ScheduledBroadcastSchema, } from './ScheduledBroadcast';
const SCHEDULED_BROADCASTS_LOCALSTORAGE_KEY = 'scheduledBroadcasts';
export class ScheduledBroadcastStore {
    scheduledBroadcasts = [];
    constructor() {
        const broadcastsFromLocalStorage = safeRetrieve(SCHEDULED_BROADCASTS_LOCALSTORAGE_KEY, 
        // biome-ignore lint/suspicious/noExplicitAny: TODO remove type when we remove the temporary migration
        (raw) => {
            const migrated = raw.map((item) => {
                const migratedItem = item;
                // temporary migration for legacy "publicKey" property name (FRONT-2247), TODO remove within few months
                if (item.publicKey !== undefined) {
                    migratedItem.broadcasterUserId = toUserId(`0x${item.publicKey}`);
                    delete migratedItem.publicKey;
                }
                // before Sep 2025 we didn't store broadcasterPrivateKey to these records: therefore here is a migration to
                // fill in the value by querying it from the key store (there should always be a matching private key in the key store
                // for this streamId as we've implictly stored it to KeyStore when we get the user name, see KeyStore:87 and KeyStore:70)
                // TODO remove within few months (also KeyStore can be removed then?)
                if (item.broadcasterPrivateKey === undefined) {
                    migratedItem.broadcasterPrivateKey =
                        KeyStore.getInstance().getPrivateKey(toStreamID(item.streamId));
                }
                // before Oct 2025 all stream IDs where in the short form, migrating those to the full form here
                // TODO remove within few months
                migratedItem.streamId = formFullStreamId(migratedItem.streamId);
                return migratedItem;
            });
            const parsed = z
                .array(ScheduledBroadcastSchema)
                .safeParse(migrated);
            return parsed.success
                ? parsed.data
                : []; // type casting so thay streamId field type is correct (it is StreamID not string)
        });
        const broadcasts = Array.isArray(broadcastsFromLocalStorage)
            ? broadcastsFromLocalStorage
            : [];
        if (broadcasts.length > 0) {
            this.setScheduledBroadcastsSorted(broadcasts);
        }
    }
    getScheduledBroadcasts() {
        return this.scheduledBroadcasts;
    }
    addScheduledBroadcast(broadcast) {
        this.setScheduledBroadcastsSorted([
            ...this.scheduledBroadcasts,
            broadcast,
        ]);
    }
    deleteScheduledBroadcast(id) {
        this.setScheduledBroadcastsSorted(this.scheduledBroadcasts.filter((b) => b.id !== id));
    }
    updateScheduledBroadcast(scheduledBroadcast) {
        this.setScheduledBroadcastsSorted(this.scheduledBroadcasts.map((b) => b.id === scheduledBroadcast.id ? scheduledBroadcast : b));
    }
    setScheduledBroadcastsSorted(broadcasts) {
        this.scheduledBroadcasts = [...broadcasts].sort((a, b) => a.startsAt - b.startsAt);
        safeStore(SCHEDULED_BROADCASTS_LOCALSTORAGE_KEY, this.scheduledBroadcasts);
    }
    clearScheduledBroadcasts() {
        this.scheduledBroadcasts = [];
        safeStore(SCHEDULED_BROADCASTS_LOCALSTORAGE_KEY, undefined);
    }
}
